// extracted by mini-css-extract-plugin
module.exports = {"container":"BsLicense_container__2JZNc","license_img":"BsLicense_license_img__4FPbW"};